/*
Author : Raphaël Dardeau

Cookie : {"code":"200","message":"This is a success!"}

Setup :

$(function() {
    $(document).alerting();
});
*/
;(function ($, window, document, undefined) {
    "use strict";
    var pluginName = "alerting",
        defaults = {
            cookieName: 'alert'
        };

    function Plugin (element, options) {
        this.element = element;
        this.settings = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {

        init: function () {
            this.getCookie();
            if (document.location.search && document.location.search.indexOf("alert") != -1) {
                if (document.location.search.indexOf("200") != -1)
                    this.datas = {"code":"200","message":"Congrats, you've been registred succesfully !"}
                else
                    this.datas = {"code":"400","message":"Sorry, an error occured."}
            }
            this.setAlert();
        },

        getCookie: function() {
            var cookie = $.cookie(this.settings.cookieName);
            if (cookie)
                this.datas = JSON.parse(cookie);
            else
                this.datas = null;
        },

        setCookie: function() {
            $.cookie(this.settings.cookieName, JSON.stringify(this.datas), {
                path: '/'
            });
        },

        setAlert: function() {
            if (this.datas) {
                if (this.datas.popinUrl) {
                    popin.setPopin({
                        url: this.datas.popinUrl,
                        classname: "popin popin--m popin--auto"
                    });
                } else if (this.datas.code && this.datas.code == 200) {
                    this.setConfirm(this.datas.message);
                } else if (this.datas.message) {
                    this.setError(this.datas.message);
                } else {
                    this.setError('Une erreur est survenue');
                }
                this.datas = null;
                this.setCookie();
            }
        },

        setError: function(message) {
            if (message) {
                var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
                html += '<p class="paragraph"><span class="message message--error">' + message +'</span></p>';
                html += '</div>';
                popin.setPopin({
                    html: html,
                    classname: "popin popin--xs popin--auto"
                });
            }
        },

        setConfirm: function(message) {
            if (message) {
                var html = '<div class="popin__head"><span class="popin__logo"></span></div><div class="popin__body">';
                html += '<p class="paragraph"><span class="message message--success">' + message +'</span></p>';
                html += '</div>';
                popin.setPopin({
                    html: html,
                    classname: "popin popin--toaster",
                    globalClassname: "is-toasting"
                });
            }
        }

    });

    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);
